export default __webpack_public_path__ + "static/media/defending.b62f3203.yaml";